import { Controller } from "@hotwired/stimulus";
import { initDropzone, initDropzoneBasicEvents } from "../components/dropzone";

export default class extends Controller {
  static targets = ["filePreviewsContainer", "uploadImgLabel", "dragAndDropContainer"];
  static values = { customOptions: Object };

  connect() {
    this._initDropzone();
  }

  _initDropzone() {
    this.dropzone = initDropzone(this.element.id, {}, this._uploadOptions());
    initDropzoneBasicEvents(this.dropzone, this.uploadImgLabelTarget, this.dragAndDropContainerTarget);
  }

  _uploadOptions() {
    const options = {
      previewsContainer: this.filePreviewsContainerTarget,
      clickable: `#${this.dragAndDropContainerTarget.id}`,
      ...this.customOptionsValue,
    };
    if (this.customOptionsValue.acceptedFileTypes) {
      options.acceptedFiles = this.customOptionsValue.acceptedFileTypes;
    }
    return options;
  }
}
